export default __webpack_public_path__ + "static/media/gallery_04.fc60f9e2.jpg";